/**
 * Greenleaze Info Icon
 * Ajoute une icône d'information avec tooltip au prix de location
 */

(function() {
  'use strict';

  function addInfoIconToPriceDisplay() {
    const priceDisplay = document.querySelector('.greenleaze-product-price-display');

    if (!priceDisplay) {
      console.log('[Greenleaze Info] Price display not found');
      return;
    }

    // Vérifier si l'icône n'existe pas déjà
    if (priceDisplay.querySelector('.info-icon')) {
      console.log('[Greenleaze Info] Info icon already exists');
      return;
    }

    // Créer l'icône info
    const infoIcon = document.createElement('span');
    infoIcon.className = 'info-icon';

    // Créer le tooltip
    const tooltip = document.createElement('span');
    tooltip.className = 'tooltip';

    // Ajouter les lignes d'information
    const infoLines = [
      'Garantie casse / vol offerte',
      'Remboursé par votre employeur',
      'Remplacement en 48h'
    ];

    infoLines.forEach(function(line) {
      const div = document.createElement('div');
      div.textContent = line;
      tooltip.appendChild(div);
    });

    infoIcon.appendChild(tooltip);
    priceDisplay.appendChild(infoIcon);

    console.log('[Greenleaze Info] Info icon added successfully');
  }

  // Essayer d'ajouter l'icône après le chargement de la page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(addInfoIconToPriceDisplay, 500);
    });
  } else {
    setTimeout(addInfoIconToPriceDisplay, 500);
  }

  // Écouter l'événement Greenleaze et réessayer
  window.addEventListener('greenleazePriceActualize', function() {
    setTimeout(addInfoIconToPriceDisplay, 300);
  });

  // Réessayer plusieurs fois au cas où
  setTimeout(addInfoIconToPriceDisplay, 1000);
  setTimeout(addInfoIconToPriceDisplay, 2000);
  setTimeout(addInfoIconToPriceDisplay, 3000);

})();
